import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/styles/form-styles.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import UserLayout from './layouts/UserLayout';
import { Provider } from 'react-redux';
import store from './redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <UserLayout />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();